import React, { forwardRef } from 'react';
import { Box, Typography } from '@mui/material';
import { PAGE_MAX_WIDTH, PAGE_GUTTER, PAGE_TOP } from '../config/layout';

/**
 * Coquille commune aux pages de l'app (Jam, You).
 *
 * Elle repond une seule fois aux questions que chaque page tranchait de son
 * cote : largeur max, gouttiere, recul du haut, qui defile, quelle reserve
 * sous la derniere carte.
 *
 * Deux boites et pas une : celle du dehors defile et prend toute la largeur,
 * pour que son ascenseur se colle au bord de la fenetre ; celle du dedans
 * porte le plafond de largeur, la gouttiere et le container CSS des cartes
 * (jam, jam-tracks). Avec le plafond sur la boite qui defile, l'ascenseur
 * tombait au milieu de l'ecran des que la fenetre depassait ce plafond.
 */
const PageShell = forwardRef(function PageShell(
  { children, label, container, desktopBrowser = false, sx, ...rest },
  ref
) {
  return (
    <Box
      component="main"
      aria-label={label}
      ref={ref}
      sx={{
        height: '100%',
        width: '100%',
        boxSizing: 'border-box',
        overflowX: 'hidden',
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch'
      }}
      {...rest}
    >
      <Box
        sx={{
          boxSizing: 'border-box',
          maxWidth: `${PAGE_MAX_WIDTH}px`,
          // Centree partout, sauf sur navigateur de bureau ou le rail de
          // gauche donne deja son bord a la page : la caler a gauche l'aligne
          // sur lui au lieu de la laisser flotter au milieu de la fenetre.
          mx: desktopBrowser ? 0 : 'auto',
          px: `${PAGE_GUTTER}px`,
          pt: `${PAGE_TOP}px`,
          // Recul sous la derniere carte pour la barre du bas. Le rail de
          // gauche du navigateur de bureau ne recouvre rien, il n'a pas besoin
          // de cette reserve.
          pb: desktopBrowser ? 3 : 12,
          ...(container && { containerType: 'inline-size', containerName: container }),
          ...sx
        }}
      >
        {children}
      </Box>
    </Box>
  );
});

/**
 * Titre de page. Une seule echelle pour toutes les pages : avant, Jam ecrivait
 * son titre en 2rem/700 et You en 27/300.
 */
export const PageTitle = ({ children, sx, ...rest }) => (
  <Typography
    component="h1"
    sx={{
      fontSize: 27,
      fontWeight: 300,
      letterSpacing: '0.5px',
      color: '#fff',
      ...sx
    }}
    {...rest}
  >
    {children}
  </Typography>
);

export default PageShell;
